var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPostService = function SvgPostService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m23.59 23.175.312 1.485a3 3 0 0 0 2.952 2.383c4.044.009 8.097 3.3 8.097 7.324v6.51H6.548v-6.51c0-4.06 4.098-7.324 8.115-7.324 1.421 0 2.645-.998 2.935-2.383.289-1.386.312-1.485.312-1.485"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.832 6.696V16.87c.02 3.813 3.103 6.919 6.918 6.919s6.898-3.098 6.918-6.919V6.696z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.91 14.02v.814M23.59 14.02v.814M21.9 19.241a1.63 1.63 0 0 1-2.301 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M23.598 10.765h-5.697a4.07 4.07 0 0 1-4.07-4.069h13.836a4.07 4.07 0 0 1-4.069 4.07M27.668 6.696H13.833a5.49 5.49 0 0 1 4.85-5.453L20.75 1l2.068.243a5.49 5.49 0 0 1 4.85 5.453"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    d: "M31 28.857V40h-5V28c1.055 0 3.837.857 5 .857"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.589 26.342c1.903 3.098 6.413 3.106 8.322 0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.589 26.342c1.903 3.098 6.413 3.106 8.322 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    d: "M8.135 39.19a8.135 8.135 0 1 0 0-16.27 8.135 8.135 0 0 0 0 16.27"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M26.854 27.043v7.324M30.109 34.367v-6.624M8.135 28.071v5.967M11.113 31.055H5.157"
  })));
};
export default SvgPostService;